import { $f } from '@/core/services/formatter';

export default {
    install: (app) => {
        app.config.globalProperties.$nb = (number, type, dp) => {
            return $f.number(number, type, dp);
        };
    },
};
